<template>
  <div>
    <el-input style="width:200px" size="mini" v-bind="show_price" v-model.number="price_model">
      <template slot="prepend">售价</template>
    </el-input>
  </div>
</template>

<script>
export default {
  name: "input-price",
  data() {
    return {
      show_price: "this.price_model"
    };
  },
  props: {
    price_model: String
  }
};
</script>

<style>
</style>